module.exports = __webpack_public_path__ + "97cf1ba876e182e28b9b4cbca61cf4c9.jpg";